import { createStructuredSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import { StructuredPresenterInterface } from './types'
import username from '../../../lib/username'
import { PRESENTER } from '../../constants/roles'

const getBTID = (state: State, props): string => props.BTID
const getPresenterLocal = (state: State, props): boolean => username.getPureUsername(state.config.username || '') === props.BTID
const getPresenterName = (state: State, props): string => {

  const participant = state.room.participantInformation.find(({ id }) => id === props.BTID)
  if (!participant) return ''
  return `${participant.firstName} ${participant.lastName}` || ''

}

const getFirstName = (state: State, props): string => {

  const participant = state.room.participantInformation.find(({ id }) => id === props.BTID)
  if (!participant) return ''
  return participant.firstName || ''

}

const getLastName = (state: State, props): string => {

  const participant = state.room.participantInformation.find(({ id }) => id === props.BTID)
  if (!participant) return ''
  return participant.lastName || ''

}

const getJobTitle = (state: State, props): string => {

  const participant = state.room.participantInformation.find(({ id }) => id === props.BTID)
  if (!participant) return ''
  return participant.jobTitle || ''

}

const getPresenterPhotoId = (state: State, props): string => {

  const participant = state.room.participantInformation.find(({ id }) => id === props.BTID)
  if (!participant) return ''
  return participant.photoId

}

const getCompanyName = (state: State, props): string => {

  const participant = state.room.participantInformation.find(({ id }) => id === props.BTID)
  if (!participant) return ''
  return participant.companyName

}

export const getRole = (state: State, props): string => {

  if (props.role) return props.role

  const participant = Object.values(state.room.participantLookup).find(({ BTID }) => BTID === props.BTID)
  if (!participant) return PRESENTER
  return participant.role

}

/**
 * Returns commonly used fields for the presenter
 * @returns an object containing id, local, name, title
 */
const structuredSelectPresenter = createStructuredSelector<State, { BTID: string, role?: string }, StructuredPresenterInterface>({
  id: getBTID,
  BTID: getBTID,
  companyName: getCompanyName,
  local: getPresenterLocal,
  name: getPresenterName,
  firstName: getFirstName,
  lastName: getLastName,
  jobTitle: getJobTitle,
  role: getRole,
  photoId: getPresenterPhotoId
})

export default structuredSelectPresenter
